import styled from 'styled-components';

export const NotFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 90px;
`;

export const NotFoundContent = styled.div`
  text-align: center;
`;
